import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              alt="Farmer's Basket Logo"
              className="h-40 w-auto"
              src="https://public.readdy.ai/ai/img_res/6da498be-7132-4da6-98e4-241857b40195.png"
            />
          </div>
          <div className="hidden lg:flex items-center space-x-8">
            {[
              { label: "公司簡介", id: "about" },
              { label: "產品展示", id: "products" },
              { label: "客戶案例", id: "testimonials" },
              { label: "出口流程", id: "process" },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-sm font-medium text-gray-700 hover:text-orange-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("contact")}
              className="px-6 py-2.5 bg-orange-700 text-white text-sm font-medium rounded-full hover:bg-orange-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              即時聯絡
            </button>
          </div>
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`text-2xl text-gray-700 ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
        {menuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-100 space-y-3 pt-4 bg-white rounded-xl px-4">
            {[
              { label: "公司簡介", id: "about" },
              { label: "產品展示", id: "products" },
              { label: "客戶案例", id: "testimonials" },
              { label: "出口流程", id: "process" },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="block w-full text-left text-sm font-medium text-gray-700 hover:text-orange-700 transition-colors whitespace-nowrap cursor-pointer py-2"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("contact")}
              className="w-full px-6 py-2.5 bg-orange-700 text-white text-sm font-medium rounded-full hover:bg-orange-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              即時聯絡
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
